// Portfolio data constants
export const PORTFOLIO_DATA = {
  personal: {
    name: "Ed Lima",
    title: "SaaS/Data/Cloud Product, Architect and Technologist",
    email: "N/A",
    location: "Seattle, WA",
    bio: "Passionate product leader with a rare balance of strong business acumen and technical knowledge, backed up by extensive experience on product management, systems architecture, design and implementation of cloud services, products, systems, software, and applications.",
  },

  navigation: [
    { name: "Home", href: "#home" },
    { name: "Media", href: "#media" },
    { name: "Publications", href: "#publications" },
    { name: "Projects", href: "#projects" },
    { name: "Let's Connect", href: "#contact" },
  ],

  social: {
    github: "https://github.com/KoldBrewEd",
    linkedin: "https://www.linkedin.com/in/ed1ima/",
    twitter: "https://x.com/ednergizer",
  },
};

// Theme constants
export const THEME = {
  colors: {
    primary: "#3B82F6",
    secondary: "#1F2937",
    accent: "#F59E0B",
    background: "#F9FAFB",
    text: "#111827",
  },

  breakpoints: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
  },
};
